module.exports = __webpack_public_path__ + "static/media/laf_blue.1da25bb6.png";